import { takeLatest } from 'redux-saga/effects';
import { registerSaga, loginSaga,dataGetDSDangChoSaga,dataChiTietCLSSaga,saveDataCLSSaga, dataGetDSHoanTatSaga } from './authenticationSaga';

import * as types from '../actions';


export default function* watchUserAuthentication() {
  yield takeLatest(types.REGISTER_USER, registerSaga);
  yield takeLatest(types.LOGIN_USER, loginSaga);
  yield takeLatest(types.DATA_DSDANGCHO, dataGetDSDangChoSaga);
  yield takeLatest(types.DATA_CHITIETCLS, dataChiTietCLSSaga);
  yield takeLatest(types.SAVE_DATA, saveDataCLSSaga);
  yield takeLatest(types.DATA_DSHOANTAT, dataGetDSHoanTatSaga);
}